/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TopUpBillingWalletResponseData
 */
export interface TopUpBillingWalletResponseData {
    /**
     * 
     * @type {string}
     * @memberof TopUpBillingWalletResponseData
     */
    redirectUrl: string | null;
}

/**
 * Check if a given object implements the TopUpBillingWalletResponseData interface.
 */
export function instanceOfTopUpBillingWalletResponseData(value: object): value is TopUpBillingWalletResponseData {
    if (!('redirectUrl' in value) || value['redirectUrl'] === undefined) return false;
    return true;
}

export function TopUpBillingWalletResponseDataFromJSON(json: any): TopUpBillingWalletResponseData {
    return TopUpBillingWalletResponseDataFromJSONTyped(json, false);
}

export function TopUpBillingWalletResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopUpBillingWalletResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'redirectUrl': json['redirectUrl'],
    };
}

  export function TopUpBillingWalletResponseDataToJSON(json: any): TopUpBillingWalletResponseData {
      return TopUpBillingWalletResponseDataToJSONTyped(json, false);
  }

  export function TopUpBillingWalletResponseDataToJSONTyped(value?: TopUpBillingWalletResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'redirectUrl': value['redirectUrl'],
    };
}

